import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-tooltip-wrapper',
  imports: [MatTooltipModule],
  template: `
    <div [matTooltip]="props.tooltip" [matTooltipPosition]="props.tooltipPosition || 'above'">
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
})
export class FormlyTooltipWrapperComponent extends FieldWrapper {}
